import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './auth.guard';
import {IpCheckGuard} from './ipcheckguard.guard'
const routes: Routes = [
{path: '', redirectTo: '/login-page', pathMatch: 'full' },

//Login Page
{path: 'login-page',loadChildren:()=>import('./login-page/login-page/login-page-module').then((m)=>m.LoginPageModule),canActivate: [IpCheckGuard]},

// Access denied
{path: 'AccessDenied', loadChildren:()=>import('./access-denied/acces-denied-module').then((m)=>m.AccessdeniedComponent) },

//Forgot Password
{path: 'forgotpassword', loadChildren:()=>import('./forgotpassword/forgotpassword-module').then((m)=>m.ForgotpasswordModule),canActivate: [IpCheckGuard] },

//Reset Password
{path: 'reset-password', loadChildren:()=>import('./reset-password/reset-password-module').then((m)=>m.ResetPasswordModule),canActivate: [IpCheckGuard] },

//Verify OTP
{path: 'verify-otp', loadChildren:()=>import('./verify-otp/verify-otp.component-module').then((m)=>m.VerifyOtpComponentModule),canActivate: [IpCheckGuard]},

//Timeout Page
{path:'timeout',loadChildren:()=>import('./timeout/timeout-module').then((m)=>m.TimeoutModule),canActivate: [IpCheckGuard]},

//Dashboard
{path: 'dashboard', loadChildren:()=>import('./dashboard/dashboard-module').then((m)=>m.DashboardModule),canActivate:[authGuard]},

// Test Panel
{path: 'testPanel', loadChildren:()=>import('./test-panel/test-panel-module').then((m)=>m.testPanelModule),canActivate:[authGuard]},

// Change Document password for all 6 modules
{ path: 'PasswordChangeRequest', loadChildren: () => import('./agreement-update-possword/agreement-update-possword.module').then(m => m.AgreementUpdatePosswordModule) }

];

@NgModule({
imports: [RouterModule.forRoot(routes)],
exports: [RouterModule]
})

export class AppRoutingModule {}